<template>
  <div class="l-side">
    <div class="l-side__inner" :style="{ top: notificationsHeight + 'px' }">
      <p class="l-side-logo">
        <router-link :to="{ name: 'projects' }" class="l-side-logo__link">
          <img
            src="@/assets/img/logo-wh.svg"
            :alt="$constants.siteName"
            class="l-side-logo__image"
          />
        </router-link>
      </p>
      <div v-if="!$constants.isDemo" class="l-side-lead">
        <p class="l-side-lead__logo">
          <img
            src="@/assets/img/logo-lead.svg"
            alt="SEARCH WRITE LEAD"
            width="160"
            height="13"
          />
        </p>
        <p class="l-side-lead__text">
          ニーズに合った情報提供で<br />オウンドメディアのCVRを改善！
        </p>
        <Button
          href="https://lead.searchwrite.jp"
          target="_blank"
          block
          fsize="f12"
          variant="orange"
          radius
          @click="clickSwLeadButton"
        >
          詳しくはこちら
        </Button>
      </div>
      <div
        class="l-side-project"
        v-click-outside="hideProjects"
        @click="toggleProjects"
      >
        <p class="l-side-project__current">
          <img :src="favicon" class="l-side-project__favicon" />
          {{ project.siteUrl }}
        </p>
        <transition name="v-fade">
          <div v-show="isVisible" class="l-side-project-modal">
            <ul class="l-side-project-modal__list">
              <li
                v-for="item in projects"
                :key="item.id"
                class="l-side-project-modal__item"
              >
                <router-link
                  :to="{
                    name: $route.name,
                    params: { projectId: item.id }
                  }"
                  class="l-side-project-modal__link"
                >
                  <p class="l-side-project-modal__name c-text--ellipsis">
                    {{ item.displayName }}
                  </p>
                  <p class="l-side-project-modal__url c-text--ellipsis">
                    <img
                      :src="getFavicon(item.siteUrl)"
                      class="l-side-project-modal__favicon"
                    />
                    {{ item.siteUrl }}
                  </p>
                </router-link>
              </li>
            </ul>
            <Button
              v-if="!$constants.isDemo && isAuthority"
              :to="{ name: 'set' }"
              block
              class="l-side-project-modal__add"
              :disabled="isLimited"
            >
              サイトを追加する
              <Icon2 variant="plus" />
            </Button>
          </div>
        </transition>
      </div>
      <dl class="l-side-nav">
        <dd class="l-side-nav__detail">
          <router-link :to="{ name: 'dashboard' }" class="l-side-nav__link">
            <Icon2 variant="dashboard" :size="16" />
            ダッシュボード
          </router-link>
        </dd>
        <dd class="l-side-nav__detail l-side-nav__detail--task">
          <router-link
            :to="{ name: 'taskList' }"
            class="l-side-nav__link l-side-nav__link--task"
            exact
          >
            <Icon2 variant="task_nav" :size="16" />
            タスクリスト
            <transition name="v-fade">
              <Label v-if="taskCount" variant="count">{{ taskCount }}</Label>
            </transition>
          </router-link>
        </dd>
        <dd class="l-side-nav__detail">
          <router-link :to="{ name: 'siteSummary' }" class="l-side-nav__link">
            <Icon2 variant="gaGscDataSummary" :size="16" />
            GA・GSCデータサマリー
          </router-link>
        </dd>
        <dd class="l-side-nav__detail">
          <a
            :href="aiWritingLink"
            target="_blank"
            class="l-side-nav__link l-side-nav__link--new"
            @click="clickAiWritingLink"
          >
            <Icon2 variant="contentPlans" :size="16" />
            AIライティング
            <Label variant="orange">NEW</Label>
          </a>
        </dd>
      </dl>
      <dl class="l-side-nav">
        <dt class="l-side-nav__title">新規コンテンツ作成</dt>
        <dd class="l-side-nav__detail l-side-nav__detail--competitive-keyword">
          <p class="l-side-nav__link" @click.stop="toggleCompetitiveKeyword">
            <Icon2 variant="competitiveKeyword" :size="16" />
            新規キーワード発見
          </p>
        </dd>
        <dd class="l-side-nav__detail" :style="cssStyle">
          <router-link
            :to="{ name: 'competitiveKeyword' }"
            class="l-side-nav__link l-side-nav__link--competitive-keyword"
          >
            関連ワードから見つける
          </router-link>
        </dd>
        <dd class="l-side-nav__detail" :style="cssStyle">
          <router-link
            :to="{ name: 'competitiveSiteKeyword' }"
            class="l-side-nav__link l-side-nav__link--competitive-keyword"
          >
            競合から見つける
          </router-link>
        </dd>
        <dd class="l-side-nav__detail">
          <router-link :to="{ name: 'contentPlans' }" class="l-side-nav__link">
            <Icon2 variant="contentPlans" :size="16" />
            コンテンツ立案
          </router-link>
        </dd>
      </dl>
      <dl class="l-side-nav">
        <dt class="l-side-nav__title">既存コンテンツ改善</dt>
        <dd class="l-side-nav__detail">
          <router-link
            :to="{ name: 'siteKeywordAnalysis' }"
            class="l-side-nav__link"
          >
            <Icon2 variant="siteSearchRank" :size="16" />
            自社キーワード分析
          </router-link>
        </dd>
        <dd class="l-side-nav__detail">
          <router-link
            :to="{ name: 'siteImportantKeyword' }"
            class="l-side-nav__link"
          >
            <Icon2 variant="siteKeywordAnalysis" :size="16" />
            成果チェック
          </router-link>
        </dd>
        <dd v-if="enabledContentRewrite" class="l-side-nav__detail">
          <router-link
            :to="{ name: 'contentRewrite' }"
            class="l-side-nav__link l-side-nav__link--content-rewrite"
          >
            <Icon2 variant="contentPlans" :size="16" />
            AIリライト提案
            <Label variant="count">Beta</Label>
          </router-link>
        </dd>
      </dl>
      <dl class="l-side-nav">
        <dt class="l-side-nav__title">その他の機能</dt>
        <dd class="l-side-nav__detail">
          <a
            class="l-side-nav__link"
            :href="leadLink"
            target="_blank"
            rel="noopener"
          >
            <Icon2 variant="cvr" :size="16" />
            CVR改善（オプション）
          </a>
        </dd>
        <dd class="l-side-nav__detail">
          <router-link
            :to="{ name: 'taskListProposals' }"
            class="l-side-nav__link l-side-nav__link--task"
            exact
          >
            <Icon2 variant="hint" :size="16" />
            自動提案改善リスト
          </router-link>
        </dd>
        <dd class="l-side-nav__detail">
          <router-link :to="{ name: 'seo' }" class="l-side-nav__link">
            <Icon2 variant="seo" :size="16" />
            SEO課題チェック
          </router-link>
        </dd>
        <dd class="l-side-nav__detail">
          <router-link :to="{ name: 'searchVolume' }" class="l-side-nav__link">
            <Icon2 variant="search" :size="16" />
            検索ボリューム調査
          </router-link>
        </dd>
      </dl>
      <ul class="l-side-support">
        <li class="l-side-support__item">
          <Button
            :to="{ name: 'reportDownload' }"
            block
            fsize="f12"
            variant="download_gy"
            radius
          >
            <Icon2 variant="download" :size="12" />
            <span>レポートダウンロード</span>
          </Button>
        </li>
        <li class="l-side-support__item">
          <a
            :href="`${$constants.serviceSiteUrl}/news`"
            target="_blank"
            class="l-side-support__link"
            data-testid="link-news"
          >
            <Icon2 variant="bell" :size="15" />
            お知らせ
          </a>
        </li>
        <li class="l-side-support__item">
          <a
            :href="$constants.supportDeskSiteUrl"
            target="_blank"
            class="l-side-support__link"
          >
            <Icon2 variant="question" :size="15" />
            よくあるご質問・機能説明
          </a>
        </li>
        <li class="l-side-support__item">
          <a
            :href="
              $constants.lpSiteUrl +
                '/offerpage_inquiry_seo_searchwrite-client.html'
            "
            target="_blank"
            class="l-side-support__link"
          >
            <Icon2 variant="mail" :size="15" />
            不具合などのお問い合わせ
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Button from '@/components/Button';
import Icon2 from '@/components/Icon2';
import Label from '@/components/Label';
import apiUsages from '@/api/usages';
import utils from '@/utils';
import Amplitude from '@/amplitude';
import FeatureFlag from '@/featureFlag';

export default {
  props: ['project'],

  components: {
    Button,
    Icon2,
    Label
  },

  data() {
    return {
      isLimited: true,
      isVisible: false,
      isVisibleCompetitiveKeyword: true
    };
  },

  computed: {
    aiWritingLink() {
      return `/f/${this.project.id}/ai-writing`;
    },
    favicon() {
      return utils.getFavicon(this.project.siteUrl);
    },
    leadLink() {
      const query = '?sw_user=true';
      const url = !this.$constants.isDemo
        ? `https://app.lead.searchwrite.jp/${query}`
        : 'https://demo.lead.searchwrite.jp';
      return url;
    },
    notificationsHeight() {
      return this.$store.state.view.size.notificationsHeight;
    },
    organization() {
      return this.$store.getters['view/organization'];
    },
    projects() {
      return this.$store.state.user.data.projects;
    },
    taskCount() {
      return this.$store.state.project.task.count;
    },
    isAuthority() {
      return this.organization.isAuthority;
    },
    cssStyle() {
      let style = {
        overflow: 'hidden'
      };
      if (!this.isVisibleCompetitiveKeyword) {
        style.height = '0px';
      }
      return style;
    },
    enabledContentRewrite() {
      return FeatureFlag.getFlag('CONTENT_REWRITE');
    }
  },

  watch: {
    'project.id': {
      handler() {
        if (!this.project.id) {
          return;
        }
        this.$store.dispatch('project/getTaskCount');
        this.getUsages();
      },
      immediate: true
    }
  },

  methods: {
    getFavicon(url) {
      return utils.getFavicon(url);
    },
    getUsages() {
      return Promise.all([this.getUsagesCount(), this.getUsagesProject()])
        .then(response => {
          const count = response[0].data; //サイト登録回数
          const project = response[1].data.items[0]; //サイト数
          this.isLimited =
            count.current >= count.max || project.current >= project.max;
        })
        .catch(error => {});
    },
    getUsagesCount() {
      let params = {
        items: 'project'
      };
      return apiUsages.count.get(params, this.auth.idToken);
    },
    getUsagesProject() {
      let params = {
        items: 'projects',
        projects: 'all'
      };
      return apiUsages.get(params, this.auth.idToken);
    },
    hideProjects() {
      this.isVisible = false;
    },
    toggleProjects() {
      this.isVisible = !this.isVisible;
    },
    toggleCompetitiveKeyword() {
      this.isVisibleCompetitiveKeyword = !this.isVisibleCompetitiveKeyword;
    },
    clickSwLeadButton() {
      Amplitude.postLogEvent('clickSwLeadButton - sideNav');
    },
    clickAiWritingLink() {
      Amplitude.postLogEvent('ClickLink to AI Writing - sideNav');
    }
  }
};
</script>
